import { ReactNode } from 'react';

const hintTextsMap: Record<string, () => ReactNode> = {
  NCM: () => (
    <div>
      <strong>Informação do Sistema</strong>
      <div>
        Caso o NCM pretendido não esteja disponível na lista para realização da declaração, o usuário deverá selecionar
        o NCM mais adequado à operação. Adicionalmente, deverá informar o NCM pretendido no campo{' '}
        <strong>Observação</strong>, utilizando o seguinte padrão:
      </div>
      <div style={{ border: '1px solid #ccc', borderRadius: '4px', padding: '4px 8px', display: 'inline-block' }}>
        NCM-&lt;número do NCM&gt;
      </div>
      <div>
        <strong>Exemplo:</strong>{' '}
        <div style={{ border: '1px solid #ccc', borderRadius: '4px', padding: '4px 8px', display: 'inline-block' }}>
          NCM-25171000
        </div>
      </div>
      <div>
        Essa informação será utilizada para análise e futuros aprimoramentos da base de classificação de NCMs do
        sistema.
      </div>
    </div>
  ),
};

/**
 * Retorna o conteúdo (ReactNode) do hint associado à chave informada.
 *
 * Utilizado em conjunto com componentes que aceitam a prop `hintText`
 * (por exemplo, `AnmSelectQuery`) para exibir textos informativos padronizados.
 *
 * @param hintKey - Chave que identifica o hint desejado. As chaves disponíveis
 *                  estão definidas em `hintTextsMap` (ex.: 'NCM').
 * @returns O ReactNode correspondente ao hint, ou `undefined` caso a chave
 *          não esteja mapeada.
 *
 * @example
 * // Em um componente:
 * <AnmSelectQuery
 *   label="Código NCM"
 *   hintText={getHintText('NCM')}
 *   // ...demais props
 * />
 *
 * @example
 * // Para adicionar um novo hint, basta incluir uma nova entrada em `hintTextsMap`:
 * // hintTextsMap['NOVA_CHAVE'] = () => (<div>Conteúdo do hint</div>);
 * // Depois, chame: getHintText('NOVA_CHAVE')
 */

export const getHintText = (hintKey: string): ReactNode => {
  const hintFunction = hintTextsMap[hintKey];
  return hintFunction ? hintFunction() : undefined;
};
